// features/modal/modalSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showSignIn: false,
  showSignUp: false,
  redirectPath: null, // 🔥 new
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openSignIn: (state, action) => {
      state.showSignIn = true;
      state.showSignUp = false;
      state.redirectPath = action.payload || null; // 🔥 new
    },
    openSignUp: (state, action) => {
      state.showSignIn = false;
      state.showSignUp = true;
      state.redirectPath = action.payload || null; // 🔥 new
    },
    closeModals: (state) => {
      state.showSignIn = false;
      state.showSignUp = false;
    },
    clearRedirectPath: (state) => {
      state.redirectPath = null;
    }
  }
});

export const { openSignIn, openSignUp, closeModals, clearRedirectPath } = modalSlice.actions;
export default modalSlice.reducer;
